import { useEffect, useState } from "react";
import InlineTabSelector from "../../inputs/InlineTabSelector";
import useUserDetails from "../../../../utils/hooks/user/useUserDetails";
import Paypal from "./paymentMethodForms/Paypal";
import BankAccount from "./paymentMethodForms/BankAcount";
import OrbitRemix from "./paymentMethodForms/OrbitRemix";

export enum PaymentMethod {
  PAYPAL = "Paypal",
  BANK_ACCOUNT = "Bank Account",
  ORBIT = "Orbit Remix"
}

const PaymentMethodSettings = () => {
  const { paymentDetails } = useUserDetails();
  const [selected, setSelected] = useState<string | undefined>();

  useEffect(() => {
    setSelected(paymentDetails?.mode);
  }, [paymentDetails?.mode]);

  return (
    <div className="text-sm">
      <p>
        {paymentDetails
          ? `You're currently setup to recieve payments via ${paymentDetails.mode}. If you want to change this, then just select or update one of the payment methods below:`
          : "Setup a payment method so that you can receive payments for reports."}
      </p>

      <InlineTabSelector
        value={selected}
        onChange={setSelected}
        tabs={Object.values(PaymentMethod)}
        className="my-6"
      />

      {selected === PaymentMethod.PAYPAL ? (
        <Paypal />
      ) : selected === PaymentMethod.BANK_ACCOUNT ? (
        <BankAccount />
      ) : selected === PaymentMethod.ORBIT ? (
        <OrbitRemix />
      ) : (
        <p className="pt-6 text-center italic">
          Select a payment method from the above options
        </p>
      )}
    </div>
  );
};

export default PaymentMethodSettings;
